import IPaymentCard from "../../models/Form/IPaymentCard";

export const initialState: IPaymentCard = {
    CardHolderName: '',
    CardNumber: '',
    CVV: '',
    ExpiryDate: '',
    // Is3DSecure: false,
}